import { http } from "@services/axios";
import axios from "axios";


async function urlToFile(url, filename = "image.jpg") {
  const res = await fetch(url);
  const blob = await res.blob();
  return new File([blob], filename, { type: blob.type });
}

/**
 * 
 * Endpoint: /product/upload/{id}/upload
 *
 * @param {number|string} productId
 * @param {Array} images - [{ file, preview, name }]
 * @returns {Promise<any>} API response
 */
export async function uploadProductImages(productId, images) {
  try {
    if (!productId) throw new Error("productId is required");

    const endpoint = `/product/upload/${productId}/upload`;

    const formData = new FormData();
    formData.append("product_id", String(productId));

    for (let i = 0; i < images.length; i++) {
      const img = images[i];

      let file = null;

      if (img?.file instanceof File) {
        file = img.file;
      }

      else if (img?.preview && (img.preview.startsWith("http") || img.preview.startsWith("blob:"))) {
        file = await urlToFile(img.preview, img.name || `image_${i}.jpg`);
      }

      if (!file) continue;

      formData.append("images[]", file);
    }

    const response = await http().post(endpoint, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });

    return response.data;
  } catch (err) {
    console.error("❌ Image upload failed:", err);
    throw err;
  }
}
